export const ROOT = '/zkt_attendances';
export const MODULE = 'ZKT_attendances';